import { Breadcrumb, BreadcrumbItem, Button } from "@carbon/react";
import i18next from "../../../i18n";

export type RequestHeaderBarProps = {
  onSaveDraft: () => void;
  onSend: () => void;
  onCancel: () => void;
  busy: boolean;
  canSubmit: boolean;
};

/**
 * The page header: a Carbon `Breadcrumb` ("Solicitudes" → "Nueva"), the page title, and the three
 * request actions. The request *name* field and the "Importar archivo" entry point moved out of
 * here into section 1 (details card) and section 2 (items card) respectively, matching the redesign
 * mockup; the old ready/incomplete summary line is gone (per-item status now lives in the table
 * rows). Save-draft and Send share the submit gate (`canSubmit`) and the busy lock.
 */
const RequestHeaderBar = ({
  onSaveDraft,
  onSend,
  onCancel,
  busy,
  canSubmit,
}: RequestHeaderBarProps) => (
  <div className="new-request-header">
    <div className="new-request-header__row">
      <div className="new-request-header__heading">
        <Breadcrumb noTrailingSlash>
          <BreadcrumbItem href="/purchase-requests">
            {i18next.t("purchaseRequests.page.breadcrumbList")}
          </BreadcrumbItem>
          <BreadcrumbItem isCurrentPage>
            {i18next.t("purchaseRequests.page.breadcrumbNew")}
          </BreadcrumbItem>
        </Breadcrumb>
        <h1 className="new-request-header__title">
          {i18next.t("purchaseRequests.page.title")}
        </h1>
      </div>

      <div className="new-request-header__actions">
        <Button kind="ghost" onClick={onCancel} disabled={busy}>
          {i18next.t("cta.cancel")}
        </Button>
        <Button
          kind="secondary"
          onClick={onSaveDraft}
          disabled={busy || !canSubmit}
        >
          {i18next.t("cta.saveDraft")}
        </Button>
        <Button onClick={onSend} disabled={busy || !canSubmit}>
          {i18next.t("cta.send")}
        </Button>
      </div>
    </div>
  </div>
);

export default RequestHeaderBar;
